import { getBannerCrop } from 'utils/banner/utils';
import { getFileName, getInputCropTypes } from 'utils/clickme';
import {
    BANNER_IMAGE_CROP_TYPES,
    BANNER_IMAGE_CROP_TYPES_CONFIG,
    CROP_CONTAINER_SIZE,
    ImageComponent,
} from 'utils/constants/banner';

import { Action } from 'store/createReducer';
import { setIsAiGenerationModalVisible } from 'store/models/aiImageGeneration';
import {
    ImageInfoResponse,
    resetBannerImages,
    setBannerImageByType,
    setIsCropImageModalVisible,
    setIsCropImageModalWasOpenedFromAiImageGenerationModal,
} from 'store/models/createBanner';
import {
    resetQuickCampaignBannerImages,
    setQuickCampaignBannerImageByType,
    setQuickCampaignIsCropImageModalVisible,
    setQuickCampaignIsCropImageModalWasOpenedFromQuickGeneration,
} from 'store/models/createQuickCampaign';
import { AppThunkAction } from 'store/utils';

export const selectGeneratedImage = (image: ImageInfoResponse, isQuickCampaign: boolean): AppThunkAction<void> => {
    return (dispatch, getState) => {
        const { id, url, width, height, availableCropsForImage } = image;

        if (isQuickCampaign) {
            dispatch(resetQuickCampaignBannerImages(null));
        } else {
            dispatch(resetBannerImages(null));
        }

        const { images: createBannerImages } = getState().createBanner;
        const { images: quickCampaignImages } = getState().createQuickCampaign;

        const images = isQuickCampaign ? quickCampaignImages : createBannerImages;

        const newImage = {
            ...image,
            fileName: getFileName(id, url),
            component: ImageComponent.Crop,
            isLoadedInCrop: false,
        };

        const inputCropTypes = getInputCropTypes(images);
        const currentCropTypes = availableCropsForImage.filter((imageCropType) =>
            inputCropTypes.includes(imageCropType)
        );

        const actions: Action[] = [];

        currentCropTypes.forEach((cropType) => {
            if (!BANNER_IMAGE_CROP_TYPES.includes(cropType)) {
                return;
            }
            const { aspect } = BANNER_IMAGE_CROP_TYPES_CONFIG[cropType];

            const image = {
                cropType,
                imageInfo: {
                    ...newImage,
                    cropInfo: getBannerCrop({
                        cropContainerSize: CROP_CONTAINER_SIZE,
                        imageWidth: width,
                        imageHeight: height,
                        cropAspect: aspect,
                    }),
                },
            };

            actions.push(isQuickCampaign ? setQuickCampaignBannerImageByType(image) : setBannerImageByType(image));
        });
        dispatch([
            ...actions,
            setIsAiGenerationModalVisible(false),
            ...(isQuickCampaign
                ? [
                      setQuickCampaignIsCropImageModalVisible(true),
                      setQuickCampaignIsCropImageModalWasOpenedFromQuickGeneration(true),
                  ]
                : [setIsCropImageModalVisible(true), setIsCropImageModalWasOpenedFromAiImageGenerationModal(true)]),
        ]);
    };
};
